import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Type } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BehaviorSubject, of, pairwise, startWith, Subscription } from 'rxjs';
import { AdminService } from 'src/app/modules/admin/services/admin.service';
import { LineItemFormComponent } from 'src/app/modules/pr-initiator/components/line-item-form/line-item-form.component';
import { RcTableFormComponent } from 'src/app/modules/pr-initiator/components/rc-table-form/rc-table-form.component';
import { PR_ACCOUNT_DETAILS_FORMFIELDS, PR_MATERIAL_MASTER_FORMFIELDS, PR_VENDOR_DETAILS_FORMFIELDS } from 'src/app/modules/pr-initiator/constants/pr-line-item-form-fields.constant';
import { IComponentInput, IMaterialCodeDetail, LineItemTabType } from 'src/app/modules/pr-initiator/models';
import { PrInitiatorHelperService } from 'src/app/modules/pr-initiator/services/pr-initiator-helper.service';
import { PrInitiatorService } from 'src/app/modules/pr-initiator/services/pr-initiator.service';
import { IAPIResponse, IBuyerRC, ILineItemDetail, IPaginatedResult, Tab } from 'src/app/modules/shared/models';
import { IFormField } from 'src/app/modules/shared/models/form-field';
import { TabService } from 'src/app/modules/shared/services/tab.service';
import { PoApproverHelperService } from '../../../services/po-approver-helper.service';
import { PrBuyerHelperService } from '../../../services/pr-buyer-helper.service';
import { ToastrService } from 'ngx-toastr';

export interface ILineItemTab {
  title: string,
  tabType: LineItemTabType,
  component: Type<any>,
  componentInput: IComponentInput
}

@Component({
  selector: 'app-create-po-lineitem-modal',
  templateUrl: './create-po-lineitem-modal.component.html',
  styleUrls: ['./create-po-lineitem-modal.component.scss']
})
export class CreatePoLineitemModalComponent implements OnInit, OnDestroy {
  // create po data
  public prData!: any;
  public qesData !: any;
  public vendorData !: any;
  public isBelowThreshold !: boolean;
  public ammendPo!: boolean;
  public title !: string;
  public hideTab: any;
  public remarks !: string;
  public totalPrice: any;
  public supplierResponseAnalysis!: any;
  public sumOfFinalFreightCharge: any;

  public onClose = new BehaviorSubject<any>({});
  @Input() purchaseRequestForm !: FormGroup;
  @Input() lineItemDetail !: any;
  @Input() rcList !: Array<IBuyerRC>;
  @Input() isMRPPr!: boolean;
  @Input() withRC!: boolean;
  @Output() lineItemAdded: EventEmitter<any> = new EventEmitter();
  public isBalanceValid: boolean = true;

  // Tab related variables
  public _prTabList: Array<ILineItemTab> = [];

  public prTabs = new Array<Tab<IComponentInput>>();
  public activeTab: Tab<IComponentInput> | undefined;
  public isRCselected: boolean = false;
  public prFiles: any = [];
  // Subscriptions
  private _subscriptions: Array<Subscription> = [];

  constructor(
    private _toastr: ToastrService,
    private _helperService: PrInitiatorHelperService,
    private _adminService: AdminService,
    private tabService: TabService,
    public bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder,
    public _prInitiatorService: PrInitiatorService,
    public _poApproverHelperService: PoApproverHelperService,
    private _buyerHelperService: PrBuyerHelperService,) {
  }

  ngOnInit(): void {
    console.log("prData in lineitem", this.prData, this.sumOfFinalFreightCharge)
    const freight_percent_or_amount = this.prData[0].quotations[0].freight_percent_or_amount;
    if(freight_percent_or_amount == "Percentage"){
      this.sumOfFinalFreightCharge = ((this.prData[0].quotations[0].quantity * this.prData[0].quotations[0].final_price)* this.prData[0].quotations[0].final_freight_charge)/100;
    }else{
      this.sumOfFinalFreightCharge = this.prData[0].quotations[0].freight_charge;
    }
    this._prTabList = [
      { title: "Material Master", tabType: LineItemTabType.MATERIAL_MASTER, component: LineItemFormComponent, componentInput: { formFields: PR_MATERIAL_MASTER_FORMFIELDS, formGroup: this._helperService.getPRLineItemMaterialMasterForm(), rcList: [], purchaseRequestForm: this.purchaseRequestForm, isMRPPr: this.isMRPPr, lineItemStatus: this.lineItemDetail?.line_item_status } },
      { title: "Account Details", tabType: LineItemTabType.ACCOUNT_DETAILS, component: LineItemFormComponent, componentInput: { formFields: PR_ACCOUNT_DETAILS_FORMFIELDS, formGroup: this._helperService.getPRLineItemAccountDetailForm(), rcList: [], tabName: "Account Details", isMRPPr: this.isMRPPr, lineItemStatus: this.lineItemDetail?.line_item_status } },
      { title: "Vendor Details", tabType: LineItemTabType.VENDOR_DETAILS, component: LineItemFormComponent, componentInput: { formFields: PR_VENDOR_DETAILS_FORMFIELDS, formGroup: this._helperService.getPRLineItemVendorDetailForm(), rcList: [], isMRPPr: this.isMRPPr, lineItemStatus: this.lineItemDetail?.line_item_status } },
      { title: "Attachments", tabType: LineItemTabType.ATTACHMENTS, component: LineItemFormComponent, componentInput: { formFields: [], formGroup: this._formBuilder.group({}), rcList: [], tabName: "Attachments", isMRPPr: this.isMRPPr, prFiles: this.prFiles, lineItemStatus: this.lineItemDetail?.line_item_status } },
    ];
    this._prTabList[this._prTabList.findIndex(x => x.tabType === LineItemTabType.MATERIAL_MASTER)].componentInput.formFields.forEach((x: IFormField) => {
      if (x.fieldName === 'currency' && x.selectFields) x.selectFields.apiAsync$ = this._adminService.getCurrency();
      if (x.fieldName === 'esn' && x.selectFields) {
        x.selectFields.apiAsync$ = this._adminService.getESNs();
        this._prTabList[0].componentInput.formGroup.controls["esn"].patchValue(this.lineItemDetail?.material_master?.esn);
      }
      if (x.fieldName === 'item_category' && x.selectFields) x.selectFields.apiAsync$ = this._adminService.getItemCategories();
      if (x.fieldName === 'ordering_unit' && x.selectFields) x.selectFields.apiAsync$ = this._adminService.getItemUnits();
      if (x.fieldName === 'service_category' && x.selectFields) x.selectFields.apiAsync$ = this._prInitiatorService.getServiceMasterCategory();
    });
    this._prTabList[this._prTabList.findIndex(x => x.tabType === LineItemTabType.ACCOUNT_DETAILS)].componentInput.formFields.forEach((x: IFormField) => {
      if (x.fieldName === "acc_assignment_category" && x.selectFields) x.selectFields.apiAsync$ = this._adminService.getAccountAssignmentCategories();
    })

    this.patchLineItemDetailForm();

    this._prTabList[this._prTabList.findIndex(x => x.tabType === LineItemTabType.MATERIAL_MASTER)].componentInput.purchaseRequestForm = this.purchaseRequestForm;
    this._prTabList[this._prTabList.findIndex(x => x.tabType === LineItemTabType.VENDOR_DETAILS)].componentInput.purchaseRequestForm = this.purchaseRequestForm;


    this._prTabList.map((tab: ILineItemTab) => {
      tab.componentInput.isMRPPr = this.isMRPPr;
    })

    this._prTabList[0].componentInput.formGroup.valueChanges.pipe(startWith(this._prTabList[0].componentInput.formGroup), pairwise()).subscribe(
      ([old, value]) => {
        if (!this.withRC && this.prTabs[0].tabData?.formGroup?.get('item_category')?.value) {
          this._prTabList[1].componentInput.itemCategory = this.prTabs[0].tabData?.formGroup?.get('item_category')?.value
        }
        this._prTabList[1].componentInput.info = { price: this.prTabs[0].tabData?.formGroup?.get('price')?.value }
      })

    this._prTabList.forEach(element => this.addNewTab(element));

    this._subscriptions.push(
      this.tabService.tabSubscription<IComponentInput>().subscribe(tabs => {
        this.prTabs = tabs;
      })
    );


    this.activeTab = this.prTabs[0];

    const accountDetailsForm = this._prTabList.find(tab => tab.tabType === LineItemTabType.ACCOUNT_DETAILS)?.componentInput.formGroup;
    const materialMasterForm = this._prTabList.find(tab => tab.tabType === LineItemTabType.MATERIAL_MASTER)?.componentInput.formGroup;

    if (accountDetailsForm) {
      accountDetailsForm.get('WBS_Balance_Value')?.valueChanges.subscribe(() => {
        this.validateBalance();
      });
    }

    if (materialMasterForm) {
      materialMasterForm.get('price')?.valueChanges.subscribe(() => {
        this.validateBalance();
      });
    }

  }

  private patchLineItemDetailForm(): void {
    this._prTabList.forEach(element => {
      if (element.tabType === LineItemTabType.MATERIAL_MASTER) {
        const priceControl = element.componentInput.formGroup.get('price') as FormControl;
        priceControl.patchValue(this.sumOfFinalFreightCharge);
        // priceControl.disable(); 
        // ((quanity * final_unit_price)* percentage)/100
      }
      if(element.tabType === LineItemTabType.VENDOR_DETAILS) {
        const vendorCode = element.componentInput.formGroup.get('vendor_code') as FormControl;
        vendorCode.patchValue(this.prData[0].supplier_id.employee_code);
        const vendorName = element.componentInput.formGroup.get('vendor_name') as FormControl;
        vendorName.patchValue(this.prData[0].supplier_id.user_name);
      }
    });
  }

  ngOnDestroy(): void {
    this.tabService.clearTabs();
    this._subscriptions.forEach(x => x.unsubscribe());
  }

  /******** Tab action related methods **********/
  private addNewTab(tabItem: ILineItemTab): void {
    // const componentName = tabItem.tabType === PRTabType.basic ? BasicDetailsComponent : RequestorDetailsComponent;
    const newTab = new Tab<IComponentInput>(tabItem.component, tabItem.title, tabItem.tabType, tabItem.componentInput);
    console.log(newTab, "NewTab")
    this.tabService.addTab<IComponentInput>(newTab);
  }

  public changeTab(tab: Tab<IComponentInput>): void {
    this.activeTab = { ...tab };
    this.tabService.updateTabStatus(tab.id - 1);
  }

  /** form valid */
  public isFormValid(): boolean {
    return this.prTabs.map(x => x.tabData?.formGroup).every(y => y?.valid == true);
  }

  public saveDetails(): void {
    if (!this.withRC) {
      let attachments: any = []
      let lineItem: ILineItemDetail = { material_master: null, vendor_details: null, account_details: null, index: this.lineItemDetail?.index };
      for (let index = 0; index < this.prTabs.length; index++) {
        const element: Tab<IComponentInput> = this.prTabs[index];
        if (element.tabType === LineItemTabType.MATERIAL_MASTER) {
          lineItem.material_master = element.tabData?.formGroup.getRawValue();
          if (this.lineItemDetail?.material_master?.rcid && lineItem.material_master) {
            lineItem.material_master.rcid = this.lineItemDetail.material_master.rcid
          } else if (lineItem.material_master) {
            lineItem.material_master.rcid = null
          }
          if (this.lineItemDetail && this.lineItemDetail.material_master?.material_master_id && lineItem.material_master) {
            lineItem.material_master.material_master_id = this.lineItemDetail.material_master?.material_master_id
          }
        }
        if (element.tabType === LineItemTabType.ACCOUNT_DETAILS) {
          lineItem.account_details = element.tabData?.formGroup.getRawValue();
          if (this.lineItemDetail && this.lineItemDetail.account_details?.account_details_id && lineItem.account_details) {
            lineItem.account_details.account_details_id = this.lineItemDetail.account_details?.account_details_id
          }
        }
        if (element.tabType === LineItemTabType.VENDOR_DETAILS) {
          lineItem.vendor_details = element.tabData?.formGroup.getRawValue();
          if (this.lineItemDetail && this.lineItemDetail.vendor_details?.vendor_details_id && lineItem.vendor_details) {
            lineItem.vendor_details.vendor_details_id = this.lineItemDetail.vendor_details?.vendor_details_id
          }
        }

        if (element.tabType === LineItemTabType.ATTACHMENTS && element.tabData?.prFiles?.length) {
          //  element.tabData?.prFiles?.forEach((file:any)=>{
          //   const idx = lineItem.index?lineItem.index:0;
          //   attachments.push(new File([file], (idx+1)+"0_"+file.file.name, {type: file.file.type}));
          //  })
        }
        if (element.tabType === LineItemTabType.RC_PROCESSING) {
          const rcData = element.tabData?.formGroup.getRawValue();
          if (lineItem.material_master) {
            if (rcData.rcid) lineItem.material_master.rcid = rcData.rcid;
            if (rcData.material_code) lineItem.material_master.material_code = rcData.material_code
          }
          if (lineItem.vendor_details) {
            if (rcData.vendor_code) lineItem.vendor_details.vendor_code = rcData.vendor_code;
            if (rcData.vendor_location) lineItem.vendor_details.vendor_location = rcData.vendor_location;
            if (rcData.vendor_name) lineItem.vendor_details.vendor_name = rcData.vendor_name;
          }
        }
      }

      const transformedData = {
        line_items: [
            {
          ...lineItem.account_details,
          ...lineItem.material_master,
          ...lineItem.vendor_details,
          index: lineItem.index,
          // ...this.prData[0].quotations[0].line_item_id,
          secondary_buyer_id: this.prData[0].quotations[0].line_item_id.secondary_buyer_id,
          forwarded_by: this.prData[0].quotations[0].line_item_id.forwarded_by,
          forwarded_by_email: this.prData[0].quotations[0].line_item_id.forwarded_by_email,
          line_item_remarks: this.prData[0].quotations[0].line_item_id.line_item_remarks,
          line_item_status: this.prData[0].quotations[0].line_item_id.line_item_status,
          item_no_of_purchase_requisition: this.prData[0].quotations[0].line_item_id.item_no_of_purchase_requisition,
          buyer_rate_contract_id: this.prData[0].quotations[0].line_item_id.buyer_rate_contract_id,
          prId: this.prData[0].quotations[0].line_item_id.prId,
          sales_order_no: this.prData[0].quotations[0].line_item_id.sales_order_no,
          esn_id: this.prData[0].quotations[0].line_item_id.esn_id,
          primary_buyer_id: this.prData[0].quotations[0].line_item_id.primary_buyer_id,
        }]}

        delete transformedData.line_items[0].material_master_id;

      // Updating the line_item_status
      transformedData.line_items[0].line_item_status = "FRIEGHT APPROVED";

      this.lineItemAdded.emit({ lineItem: transformedData, prFiles: this.prFiles })
      this.closeModal(lineItem);

      console.log("sending data line_Item", transformedData)
      this._poApproverHelperService.saveLineItemData(transformedData).subscribe((res: any) => {
        console.log("res", res)
        if (res.status == 200) {
          console.log("success");
          const modalRef = this._buyerHelperService.openCreatePOModal(this.prData, [], this.vendorData, true, '', false)
        } else {
          console.log(res);
          this._toastr.error(res.error.message);
        }
      }, err => {
      this._toastr.error(err.message);
    });
    } else {
      console.log(this._prTabList[0].componentInput.rcLineItems)
      this.closeModal(this._prTabList[0].componentInput.rcLineItems)
      this.lineItemAdded.emit(this._prTabList[0].componentInput.rcLineItems)
    }
  }


  /******** Method to be used to get data output from dynamically created component **********/
  public onTabDataUpdate(data: any): void {
    console.log(data);
    // this.onClose.next(data);
  }

  /******** Method to be used for closing modal **********/
  public closeModal(data?: ILineItemDetail) {
    // this.lineItemAdded.emit(null)
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public onModalClose(): void {
    this.lineItemAdded.emit()
    this.bsModalRef.hide()
  }

  validateBalance() {
    const accountDetailsForm = this._prTabList.find(tab => tab.tabType === LineItemTabType.ACCOUNT_DETAILS)?.componentInput.formGroup;
    const materialMasterForm = this._prTabList.find(tab => tab.tabType === LineItemTabType.MATERIAL_MASTER)?.componentInput.formGroup;

    if (accountDetailsForm && materialMasterForm) {
      const wbcBalanceValue = accountDetailsForm.get('WBS_Balance_Value')?.value;
      const wbcBalance = materialMasterForm.get('price')?.value;

      this.isBalanceValid = Number(wbcBalanceValue) >= Number(wbcBalance);

    } else {
      this.isBalanceValid = true;

    }
  }

}


